import React, { useEffect, useState } from 'react'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import { superAxiosRequest } from 'axiosApi'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import st from 'components/ContentBox/Global/ReportTable/Table.module.scss'
import { useHistory } from 'react-router-dom'
import { ExcelRowsParams } from 'components/utils/ExcelExport'
import ExportExcelButton from '../ExportExcelButton/ExportExcelButton'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import { observer } from 'mobx-react'
import styles from './ClientsDiscount.module.scss'
import ReportRow from '../components/ReportRow/ReportRow'
import Pagination from 'components/UI/Pagination/Pagination'
import { localisationMaster } from 'Localisation/Localisation'
import DiscountDates from 'components/ContentBox/Global/GlobalModalSingle/templates/groups/DiscountDates'
import listingStore from 'Stores/listingStore'
import modalStore from 'Stores/modalStore'

const initPagination = {
  page: 1,
  limit: 10,
}

const ClientsDiscount = () => {
  const history = useHistory()
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [dataLength, setDataLength] = useState(0)
  const [filter, updateFilter] = useLocalStorageFilter({})
  const [pagination, setPagination] = useState(initPagination)
  const [catalog, setCatalog] = useState([])

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const filterCfg = [
    {
      type: 'input',
      label: 'Имя или почта студента',
      placeholder: 'Имя или почта студента',
      nameState: 'search',
    },
    {
      type: 'input',
      label: 'Имя или номер группы',
      placeholder: 'Имя или номер группы',
      nameState: 'group',
    },
    {
      type: 'select',
      label: 'Скидка',
      nameState: 'discount_id',
      placeholder: 'Скидка',
      values: catalog?.discounts,
      option_value_key: 'id',
      option_label_key: 'name',
    },
    {
      type: 'select',
      label: 'Локация',
      nameState: 'location',
      placeholder: 'Локация',
      values: catalog?.locations,
      option_value_key: 'id',
      option_label_key: 'name',
    },
    {
      type: 'type_selector',
      nameState: 'actual',
      label: 'Формат',
      values: [
        { id: 0, name: 'Все клиенты' },
        { id: 1, name: 'Только актуальные' },
      ],
    },
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: 'Период',
    },
  ]

  const rowsData = (student) => ({
    mainFields: [
      { value: student.student_name },
      { value: student.group_name },
      { value: student.discount_name, red: true },
    ],
    openedContent: [
      { header: 'Group', content: student.group_name },
      { header: 'Discount', content: student.discount_name, red: true },
      {
        header: 'Responsible',
        content: student.responsible || 'Not indicated',
      },
      { header: 'Telephone', content: student.phone || 'Not indicated' },
      { header: 'Email', content: student.email || 'Not indicated' },
      { header: 'Start date', content: student.date_from || 'Not indicated' },
      { header: 'End date', content: student.date_until || 'Not indicated' },
    ],
  })

  const fetchData = (filter) => {
    setIsLoading(true)

    const params = {
      ...filter,
    }

    superAxiosRequest({
      method: 'get',
      link: 'groups/discounts_only_new',
      params: params,
    })
      .then((res) => {
        setData(res.data.result || [])
        setCatalog(res.data)
        setDataLength(res.data._meta?.count_items)
        setIsLoading(false)
      })
      .catch(() => {
        setData([])
        setIsLoading(false)
      })
  }

  useEffect(() => {
    fetchData(filter)
  }, [filter, pagination]) // eslint-disable-line

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/reports/clients-discount') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const downloadExcel = () => {
    setIsLoading(true)

    const params = {
      ...filter,
      offset: 0,
      limit: dataLength,
    }

    superAxiosRequest({
      method: 'get',
      link: 'groups/discounts_only_new',
      params: params,
    })
      .then((res) => {
        const fullData = res.data.result

        import('xlsx-js-style').then((XLSX) => {
          const headRow = [
            { v: 'Ф.И.О. студента', ...ExcelRowsParams.headerRowParam },
            { v: 'Группа', ...ExcelRowsParams.headerRowParam },
            { v: 'Скидка', ...ExcelRowsParams.headerRowParam },
          ]
          let tableData = []

          let wscols = [{ wch: 40 }, { wch: 30 }, { wch: 40 }]
          let rows = [{ hpx: 30 }]

          fullData.forEach((studentItem) => {
            tableData.push([
              {
                v: studentItem.student_name,
                ...ExcelRowsParams.tableRowParam.firstCell,
              },
              {
                v: studentItem.group_name,
                ...ExcelRowsParams.tableRowParam.cell,
              },
              {
                v: studentItem.discount_name,
                ...ExcelRowsParams.tableRowParam.cell,
              },
            ])
          })

          const wb = XLSX.utils.book_new()
          const ws = XLSX.utils.aoa_to_sheet([headRow, ...tableData])
          ws['!cols'] = wscols
          ws['!rows'] = rows
          XLSX.utils.book_append_sheet(wb, ws, 'Клиенты со скидками')

          XLSX.writeFile(wb, 'Клиенты со скидками.xlsx')
        })
      })
      .catch((err) => {
        console.error('Ошибка при загрузке данных:', err)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const generateMenu = () => [
    { name: 'Перейти в профиль', action: 'go_to_profile' },
    { name: 'Перейти в группу', action: 'go_to_group' },
    { name: 'Редактировать скидку', action: 'edit_discount_dates' },
  ]

  const handleAction = (action, student) => {
    let modalSettings, modalData

    switch (action) {
      case 'go_to_profile':
        window.open(`/account_clients/${student.student_id}`, '_blank')
        break

      case 'go_to_group':
        window.open(`/groups/group/${student.group_id}`, '_blank')
        break

      case 'edit_discount_dates':
        modalSettings = {
          title: student.student_name,
          modalBodyComponent: () => <DiscountDates />,
          button: localisationMaster('text_54', 'groups/all-groups'),
          is_put: true,
          link: `groups/student_discounts/${student.id}`,
          func: (data) => {
            const updatedStudent = data.students.find(
              (st) => st.id === student.student_id,
            )
            const discount = updatedStudent.group_status.discount_list.find(
              (dis) => dis.id === student.discount_id,
            )
            if (updatedStudent && discount) {
              listingStore.putRow({
                ...student,
                date_from: discount.date_from,
                date_until: discount.date_until,
              })
            }
          },
        }

        modalData = {
          client_id: student.student_id,
          discount_id: student.discount_id,
          group_id: student.group_id,
          date_from: student.date_from,
          date_until: student.date_until,
        }

        modalStore.activity(modalSettings, modalData)
        break

      default:
        console.warn('Неизвестное действие:', action)
    }
  }

  return (
    <>
      <ContentHeader title='Клиенты со скидками'>
        <SearchBooks
          onSearch={(text) => {
            updateFilter({ ...filter, search: text })
            changeTextValue('search', {
              key: 'search',
              label: 'Search',
              value: text,
            })
          }}
          onClear={() => {
            const { search, ...obj } = filter
            updateFilter(obj)
            setTextValues(
              filterTextValues.filter((field) => field.key !== 'search'),
            )
          }}
          translate={translate}
          placeholder={`Search...`}
          value={filter?.search || ''}
        />
        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const { [key]: _, ...obj } = filter
              updateFilter(obj)
            }}
          />
        )}
        {isOpenFilter && (
          <AsideFilter
            translate={translate}
            getFilterParams={updateFilter}
            config={filterCfg}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
          />
        )}
      </ContentHeader>

      {isLoading ? (
        <Loader />
      ) : Array.isArray(data) && data.length === 0 ? (
        <h1 className={st.noData}>Нет данных для отображения!</h1>
      ) : (
        <>
          {data && (
            <div className={styles.excelBtn}>
              <ExportExcelButton downloadExcel={downloadExcel} data={data} />
            </div>
          )}
          <div className={styles.list}>
            {data && (
              <div className={styles.listHeader}>
                Entries: {isLoading ? 'Loading...' : dataLength}
              </div>
            )}
            {data.map((student, index) => (
              <ReportRow
                key={index}
                config={rowsData(student)}
                menu={generateMenu()}
                action={(action) => handleAction(action, student)}
              />
            ))}
          </div>

          <div className={styles.pagination}>
            <Pagination
              limit={pagination.limit}
              count={dataLength}
              page={pagination.page}
              onChange={(page) => setPagination({ ...pagination, page })}
              onChangePerPage={(limit) => setPagination({ page: 1, limit })}
            />
          </div>
        </>
      )}
    </>
  )
}

export default observer(ClientsDiscount)
